module.exports = __webpack_public_path__ + "static/Anas-0f6fd35f5002fa92f59e528df8626d5b.jpg";